import { z } from 'zod'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }

  return { message: ctx.defaultError }
})

export const exerciseSheetScheme = z.object({
  id: z.string().optional(),
  nome: z.string().min(1, 'Este campo é obrigatório'),
  dataInicio: z
    .string(),
  dataFim: z
    .string(),
  tipoDuracao: z.string().default('TREINOS').optional().nullable(),
  numeroTreinos: z
    .union([
      z.number(),
      z.string().min(1, 'Este campo é obrigatório')
    ]).transform((value) => {
      const parsedValue = typeof value === 'string' ? parseInt(value, 10) : value
      if (isNaN(parsedValue)) {
        throw new Error('Número de treinos inválido')
      }
      return parsedValue
    }),
  // frequencia: z.string().min(1, 'Este campo é obrigatório'),
  //tempoPausaSeries: z
  //  .union([
  //    z.number(),
  //    z.string().min(1, 'Este campo é obrigatório')
  //  ]).transform((value) => {
  //    const parsedValue = typeof value === 'string' ? parseInt(value, 10) : value
  //    if (isNaN(parsedValue)) {
  //      throw new Error('Número de treinos inválido')
  //    }
  //    return parsedValue
  //  }),
  // velocidadeExecucao: z.string().min(1, 'Este campo é obrigatório'),
  tipoImpressao: z.string().default('IMPRESSORA').optional().nullable(),
  //observacao: z.string().optional(),
  ocultarFichaApp: z.boolean().default(false).optional(),
  fichaModelo: z.boolean().default(false).optional(),
  treinosEfetuados: z.number().default(0).optional(),
  autoAvaliacao: z
    .union([
      z.number().optional(),
      z.string().optional()
    ]),
  professor: z.object({ id: z.any() }),
  aluno: z.object({ id: z.any() }),
  unidade: z.object({
    id: z.union([z.number().int(), z.string()])
  })
})

export type ExerciseSheetForm = z.infer<typeof exerciseSheetScheme>
